// 本地
module.exports = {
  // 2.0
  baseUrl: 'http://syp.ytsaas.com', // 收银台正式项目地址
  baseApi: 'local', // 正式api请求地址
};
